import { api } from '../api';

// Action Types

export const Types = {
  SETCOMPANYDATA: 'set/company/data',
};

// Reducer

const initialState = {
  companyId: null,
  companyData: null,
  open: false,
  companyList: [],

};

export default (state = initialState, action) => {

  switch (action.type) {
    case Types.SETCOMPANYDATA:
      return { ...state, ...action.result };
    default:
      return state;
  }

};

// Action Creators

export const setCompanyData = params => ({
  type: Types.SETCOMPANYDATA,
  result: params || initialState,
});



// WEBPACK FOOTER //
// ./src/redux/company.js